export const ANDROID_CLIENT_APP_LINK =
    'https://play.google.com/store/apps/details?id=com.getresq.resqfm';
export const APPLE_CLIENT_APP_LINK = 'https://apps.apple.com/ca/app/resq/id1187231508';
export const ANDROID_VENDOR_APP_LINK =
    'https://play.google.com/store/apps/details?id=com.getresq.resqvm';
export const APPLE_VENDOR_APP_LINK = 'https://apps.apple.com/ca/app/resq-vendor/id1193627383';
